export default __webpack_public_path__ + "static/media/Logo_GO.6c63049c.png";